<template>
  <DragDialog
    title="添加发布平台"
    :width="600"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel"
  >
    <div class="import-box">
      <div class="common-form-box">
        <el-form :model="form" class="public-form-primary" :rules="rules" label-width="94px" ref="form">
          <el-form-item
            label="设置名称："
            prop="platformName"
            class="common-input-box"
          >
            <el-input
            class="input-primary"
              size="small"
              v-model="form.platformName"
              placeholder="请为发布平台设置一个名称"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";
import { addPlatformService } from "@/service/interface";

export default {
  data() {
    return {
      form: {
        platformName: "",
      },
      rules: {
        platformName: [
          {
            required: true,
            message: "请为发布平台设置一个名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: {
    visible: Boolean,
    closeDialog: Function,
  },
  components: { DragDialog },
  methods: {
    submit() {
      let params = {
        resultCount: 100,
        skipCount: 0,
        name: this.form.platformName,
      };
      addPlatformService(params).then((response) => {
        if (response.isSuccess) {
          this.$message.success("添加成功");
          this.$eventManage.fire("refreshPlatFormList", {});
          this.cancel();
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    cancel() {
      this.form = {
        platformName: "",
      };
      this.closeDialog();
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
@import "@/assets/css/pageStyle.less";
</style>